import {
    getThisOrThatTextColor,
    THISORTHAT_ALLOWED_BACKGROUND_COLORS,
} from '../../templates/inputs/PollThisOrThatInput';
import {
    EMPTY_TRANSLATION_TABLE,
    MultiChoicePollAlternative,
    MultiChoicePollData,
    PollData,
    PortalPollType,
    ThisOrThatPollData,
    VoteSliderPollData,
} from '@lifeserver/shared';

export type {
    MultiChoiceArticlePage,
    ThisOrThatArticlePage,
    VoteSliderArticlePage,
} from '@lifeserver/shared';

export function getDefaultMultiChoiceAlternative(): MultiChoicePollAlternative {
    return {
        backgroundColor: THISORTHAT_ALLOWED_BACKGROUND_COLORS[0],
        backgroundType: 'plain',
        iconName: '',
        result: 0,
    };
}

export function getDefaultPollByType(
    pollType: 'MultiChoice',
): MultiChoicePollData;
export function getDefaultPollByType(
    pollType: 'ThisOrThat',
): ThisOrThatPollData;
export function getDefaultPollByType(
    pollType: 'VoteSlider',
): VoteSliderPollData;
export function getDefaultPollByType(pollType: PortalPollType): PollData {
    switch (pollType) {
        case 'ThisOrThat': {
            return {
                $type: 'ThisOrThat',
                id: crypto.randomUUID(),
                position: { x: 0, y: 0 },
                size: 'Medium',
                alternatives: [
                    {
                        backgroundColor:
                            THISORTHAT_ALLOWED_BACKGROUND_COLORS[0],
                        textColor: getThisOrThatTextColor(
                            THISORTHAT_ALLOWED_BACKGROUND_COLORS[0],
                        ),
                        iconName: '',
                        result: 0,
                    },
                    {
                        backgroundColor:
                            THISORTHAT_ALLOWED_BACKGROUND_COLORS[0],
                        textColor: getThisOrThatTextColor(
                            THISORTHAT_ALLOWED_BACKGROUND_COLORS[0],
                        ),
                        iconName: '',
                        result: 0,
                    },
                ],
            };
        }
        case 'VoteSlider':
            return {
                $type: 'VoteSlider',
                id: crypto.randomUUID(),
                position: { x: 0, y: 0 },
                alternatives: [
                    {
                        iconName: '',
                        result: 0,
                    },
                ],
            };
        case 'MultiChoice':
            return {
                $type: 'MultiChoice',
                id: crypto.randomUUID(),
                question: EMPTY_TRANSLATION_TABLE,
                alternatives: [
                    getDefaultMultiChoiceAlternative(),
                    getDefaultMultiChoiceAlternative(),
                ],
            };
        default:
            throw new Error(`Unknown poll type: ${pollType}`);
    }
}
